<template>
  <div class="p-grid">
    <div class="p-col-12">
      <Card>
        <template #title="">
          <div class="p-d-flex p-justify-between">
            เอกสารอบรมต้นสังกัด
            <div>
              <Button
                icon="pi pi-save"
                label="บันทึก"
                @click="onSaveDocument"
                :disabled="isReadonly"
              >
              </Button>
              <Button
                v-if="documentId !== 'N/A'"
                icon="pi pi-send"
                label="ส่งเอกสาร"
                @click="onSubmitDocument"
                class="p-ml-2 p-button-danger"
                :disabled="isReadonly"
              >
              </Button>
              <Button
                v-if="documentId !== 'N/A'"
                icon="pi pi-print"
                label="พิมพ์"
                @click="onExportDocument"
                class="p-ml-2 p-button-text"
              >
              </Button>
              <CancelButton
                @cancel="onCancelDocument"
                v-if="
                  (isAdmin ||
                    onTheJobDocument.createById ===
                      sessionState.profile.employeeId) &&
                    documentId !== 'N/A'
                "
                :disabled="isReadonly"
                class="p-ml-2"
              />
              <BackButton class="p-ml-2"></BackButton>
            </div>
          </div>
        </template>
        <template #subtitle="">
          <StatusBadge :status="statusText"></StatusBadge> &nbsp;
          <small v-if="onTheJobDocument.createById"
            >สร้างโดย {{ onTheJobDocument.createById }}&nbsp;</small
          >
          <small v-if="onTheJobDocument.submittedDate"
            >ส่งเอกสารให้ HRD เมื่อ 
            {{ formatAppDateTime(onTheJobDocument.submittedDate) }}&nbsp;</small
          >
          <small v-if="onTheJobDocument.cancelById"
            >ยกเลิกโดย {{ onTheJobDocument.cancelById }} ยกเลิกเมื่อ
            {{ formatAppDateTime(onTheJobDocument.cancelOn) }}</small
          >
        </template>
        <template #content="">
          <div class="p-grid">
            <div class="p-col-12 p-md-3 p-fluid p-form">
              <span class="p-float-label">
                <InputText v-model="documentId" id="id" readonly></InputText>
                <label for="id">เลขที่เอกสาร</label>
              </span>
            </div>
            <div class="p-col-12 p-md-9 p-fluid p-field">
              <span class="p-float-label">
                <InputCourse
                  id="courseId"
                  v-model="onTheJobDocument.courseId"
                  :class="{ 'p-invalid': v$.onTheJobDocument.courseId.$error }"
                  :disabled="isReadonly"
                ></InputCourse>
                <label for="courseId">หลักสูตร</label>
              </span>
              <small
                class="p-error"
                v-if="v$.onTheJobDocument.courseId.$error"
                >{{ v$.onTheJobDocument.courseId.required.$message }}</small
              >
            </div>
            <div class="p-col-12 p-lg-3 p-md-4 p-fluid p-form">
              <span class="p-float-label">
                <Calendar
                  v-model="onTheJobDocument.documentDate"
                  id="documentDate"
                  :disabled="isReadonly"
                ></Calendar>
                <label for="documentDate">วันที่</label>
              </span>
              <small
                class="p-error"
                v-if="v$.onTheJobDocument.documentDate.$error"
                >{{ v$.onTheJobDocument.documentDate.required.$message }}</small
              >
            </div>
            <div class="p-col-12 p-lg-3 p-md-4 p-fluid p-form">
              <span class="p-float-label">
                <InputText
                  v-model="onTheJobDocument.location"
                  id="location"
                  :class="{ 'p-invalid': v$.onTheJobDocument.location.$error }"
                  :disabled="isReadonly"
                ></InputText>
                <label for="location">สถานที่</label>
              </span>
              <small
                class="p-error"
                v-if="v$.onTheJobDocument.location.$error"
                >{{ v$.onTheJobDocument.location.required.$message }}</small
              >
            </div>
            <div class="p-col-12">
              <span class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <RadioButton
                    :class="{ 'p-invalid': v$.selectedTopic.$error }"
                    v-model="v$.selectedTopic.$model"
                    :value="description.main"
                    name="topic"
                    :disabled="isReadonly"
                  ></RadioButton>
                </span>
                <span class="p-inputgroup-addon">
                  {{ description.main }}
                </span>
                <InputText
                  v-model="mainTopic"
                  :class="{ 'p-invalid': v$.mainTopic.$error }"
                  :disabled="isReadonly"
                />
              </span>

              <small class="p-error" v-if="v$.mainTopic.$error">{{
                v$.mainTopic.requiredIf.$message
              }}</small>
            </div>
            <div class="p-col-12">
              <span class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <RadioButton
                    :class="{ 'p-invalid': v$.selectedTopic.$error }"
                    v-model="v$.selectedTopic.$model"
                    :value="description.optional"
                    name="topic"
                    :disabled="isReadonly"
                  ></RadioButton>
                </span>
                <span class="p-inputgroup-addon">
                  {{ description.optional }}
                </span>
                <InputText
                  v-model="optionTopic"
                  :class="{ 'p-invalid': v$.optionTopic.$error }"
                  :disabled="isReadonly"
                />
              </span>
              <small class="p-error" v-if="v$.optionTopic.$error">{{
                v$.optionTopic.requiredIf.$message
              }}</small>
            </div>
            <div class="p-col-12">
              <span class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <RadioButton
                    :class="{ 'p-invalid': v$.selectedTopic.$error }"
                    v-model="v$.selectedTopic.$model"
                    :value="description.other"
                    name="topic"
                    :disabled="isReadonly"
                  ></RadioButton>
                </span>
                <span class="p-inputgroup-addon">
                  {{ description.other }}
                </span>
                <InputText
                  v-model="otherTopic"
                  :class="{ 'p-invalid': v$.otherTopic.$error }"
                  :disabled="isReadonly"
                />
              </span>
              <small class="p-error" v-if="v$.otherTopic.$error">{{
                v$.otherTopic.requiredIf.$message
              }}</small>
            </div>
            <small class="p-error" v-if="v$.selectedTopic.$error"
              >กรุณาระบุเรื่องที่ทำการอบรมก่อน</small
            >
            <div class="p-col-12">
              <div class="p-d-flex p-justify-between">
                <span style="font-size: 1.2rem; font-weight: bold">
                  รายชื่อผู้เข้ารับการฝึกอบรมและผลการประเมิน
                </span>
                <div>
                  <Button
                    icon="pi pi-user-plus"
                    label="เพิ่มผู้เข้าร่วมอบรม"
                    @click="onAddAttendee"
                    :disabled="isReadonly"
                  ></Button>
                </div>
              </div>
            </div>
            <div class="p-col-12">
              <DataTable :value="onTheJobDocument.items" class="p-datatable-sm">
                <template #empty="">ไม่พบข้อมูล</template>
                <template #footer="">
                  จำนวนผู้เข้าร่วมอบรมทั้งหมด
                  {{
                    onTheJobDocument.items?.filter((x) => x.employeeId)
                      .length ?? 0
                  }}
                  คน</template
                >
                <Column header="พนักงาน">
                  <template #body="props">
                    <div class="p-fluid">
                      <InputUser
                        v-model="props.data.employeeId"
                        required
                        showClear
                        :disabled="isReadonly"
                      ></InputUser>
                    </div>
                  </template>
                </Column>
                <Column
                  header="ผลการประเมิน"
                  headerStyle="width:18rem"
                  bodyStyle="width:18rem"
                >
                  <template #body="props">
                    <div class="p-fluid">
                      <InputOnTheJobScore
                        :optionalCourse="selectedTopic !== description.main"
                        v-model="props.data.score"
                        v-model:required="submitting"
                        :disabled="isReadonly"
                      >
                      </InputOnTheJobScore>
                    </div>
                  </template>
                </Column>
                <Column headerStyle="width: 4rem" bodyStyle="width:4rem">
                  <template #body="props">
                    <Button
                      class="p-button-rounded p-button-danger"
                      icon="pi pi-minus"
                      @click="() => onDeleteAttendee(props.index)"
                      :disabled="isReadonly"
                    ></Button>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </template>
      </Card>
    </div>
    <div class="p-col-12">
      <Card>
        <template #subtitle="">
          เอกสารแนบ
        </template>
        <template #content="">
          <div class="p-grid">
            <div class="p-col-12">
              <AttachmentPanel
                :documentId="onTheJobDocument.id"
                :disabled="isReadonly"
              />
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, nextTick } from "vue";
import { usePlugin } from "@/plugins";
import {
  OnthejobDocument,
  OnthejobItem,
  UpsertOnTheJobDocumentRequest,
  GetOnTheJobDocumentRequest,
  GetOnTheJobDocumentResponse,
  UpsertOnTheJobDocumentResponse,
  DownloadOnTheJobDocumentRequest,
  CancelOnTheJobDocumentRequest,
} from "@/types";
import InputCourse from "@/components/InputCourse.vue";
import InputUser from "@/components/InputUser.vue";
import InputOnTheJobScore from "@/components/InputOnTheJobScore.vue";
import AttachmentPanel from "@/components/AttachmentPanel.vue";
import useVuelidate from "@vuelidate/core";
import StatusBadge from "@/components/StatusBadge.vue";
import CancelButton from "@/components/CancelButton.vue";
import { required, requiredIf, helpers } from "@vuelidate/validators";
import { saveAs } from "file-saver";
import { useConfirm } from "primevue/useconfirm";
import { useSessionState } from "@/store";

export default defineComponent({
  name: "OnTheJobDocumentScreen",
  components: {
    InputCourse,
    InputUser,
    InputOnTheJobScore,
    AttachmentPanel,
    StatusBadge,
    CancelButton,
  },
  setup() {
    const {
      axios,
      error,
      success,
      setLoading,
      dayjs,
      route,
      onRouterReplace,
      isAdmin,
      useSessionState,
      formatAppDateTime,
      confirmation,
    } = usePlugin();
    const initialData: OnthejobDocument = {
      id: null,
      documentDate: dayjs().toDate(),
      submittedDate: null,
      location: null,
      courseId: null,
      body: null,
      items: [],
      createById: null,
      createBy: null,
      course: null,
      cancelOn: null,
      cancelById: null,
      cancelBy: null,
      status: null,
    };
    const sessionState = useSessionState();
    const onTheJobDocument = ref<OnthejobDocument>(initialData);
    const selectedTopic = ref("");
    const mainTopic = ref("");
    const optionTopic = ref("");
    const otherTopic = ref("");
    const submitting = ref(false);
    const description = {
      main: "ทักษะ/ความรู้จำเป็นในการทำงานเรื่อง",
      optional: "ทักษะ/ความรู้เสริมเรื่อง",
      other: "อื่น ๆ",
    };

    const rules = computed(() => ({
      onTheJobDocument: {
        documentDate: { required },
        location: { required },
        courseId: { required },
      },
      selectedTopic: { required },
      mainTopic: {
        requiredIf: requiredIf(() => {
          return selectedTopic.value === description.main;
        }),
      },
      optionTopic: {
        requiredIf: requiredIf(() => {
          return selectedTopic.value === description.optional;
        }),
      },
      otherTopic: {
        requiredIf: requiredIf(() => {
          return selectedTopic.value === description.other;
        }),
      },
    }));
    const v$ = useVuelidate(
      rules,
      {
        onTheJobDocument,
        selectedTopic,
        mainTopic,
        optionTopic,
        otherTopic,
      },
      { $autoDirty: true }
    );
    const onSaveDocument = async () => {
      submitting.value = false;
      await nextTick();
      v$.value.$reset();
      v$.value.$touch();
      if (!(await v$.value.$validate())) return;

      setLoading(true);
      try {
        onTheJobDocument.value.body = `${selectedTopic.value}${
          selectedTopic.value === description.main
            ? mainTopic.value
            : selectedTopic.value === description.optional
            ? optionTopic.value
            : otherTopic.value
        }`;
        var result = await axios.post<UpsertOnTheJobDocumentResponse>(
          "api/v1/services/onTheJobDocument/upsert",
          {
            document: onTheJobDocument.value,
          } as UpsertOnTheJobDocumentRequest
        );
        if (!route.params["id"]) {
          await onRouterReplace({
            name: "editOnTheJobDocument",
            params: { id: result.data.documentId },
          });
          await loadDocument();
        } else {
          await loadDocument();
        }
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const loadDocument = async () => {
      if (!route.params["id"]) return;
      setLoading(true);
      try {
        var result = await axios.post<GetOnTheJobDocumentResponse>(
          "api/v1/services/onTheJobDocument",
          {
            id: route.params["id"],
          } as GetOnTheJobDocumentRequest
        );
        if ((result.data.onTheJobDocuments?.length ?? 0) > 0) {
          onTheJobDocument.value = result.data.onTheJobDocuments[0];
          onTheJobDocument.value.documentDate = dayjs(
            onTheJobDocument.value.documentDate ?? ""
          ).toDate();
          if (onTheJobDocument.value.body?.startsWith(description.main)) {
            selectedTopic.value = description.main;
            mainTopic.value = onTheJobDocument.value.body.replace(
              description.main,
              ""
            );
          }
          if (onTheJobDocument.value.body?.startsWith(description.optional)) {
            selectedTopic.value = description.optional;
            optionTopic.value = onTheJobDocument.value.body.replace(
              description.optional,
              ""
            );
          }
          if (onTheJobDocument.value.body?.startsWith(description.other)) {
            selectedTopic.value = description.other;
            otherTopic.value = onTheJobDocument.value.body.replace(
              description.other,
              ""
            );
          }
        } else {
          throw Error(
            "ไม่สามารถดึงข้อมูลได้ กรุณาตรวจสอบสิทธิการใช้งานระบบอีกครั้ง"
          );
        }
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onSubmitDocument = async () => {
      confirmation.require({
        header: "ส่งเอกสารให้ HRD",
        message: "กรุณายืนยันเพื่อส่งเอกสารให้ HRD",
        acceptLabel: "ยืนยันส่งเอกสาร",
        rejectLabel: "ปิด",
        accept: async () => {
          submitting.value = true;
          await nextTick();
          v$.value.$reset();
          v$.value.$touch();
          if (!(await v$.value.$validate())) return;

          onTheJobDocument.value.submittedDate = dayjs().toDate();
          await onSaveDocument();
        },
      });
    };

    const onExportDocument = async () => {
      submitting.value = false;
      await nextTick();
      v$.value.$reset();
      v$.value.$touch();
      if (!(await v$.value.$validate())) return;

      confirmation.require({
        header: "แสดงคะแนนหรือไม่?",
        message: "คุณต้องการแสดงคะแนนด้วยหรือไม่?",
        acceptLabel: "แสดงคะแนน",
        rejectLabel: "ไม่แสดงคะแนน",
        accept: async () => {
          setLoading(true);
          try {
            const result = await axios.post(
              "api/v1/services/onTheJobDocument/download",
              {
                documentNo: onTheJobDocument.value.id,
                printScore: true,
              } as DownloadOnTheJobDocumentRequest,
              { responseType: "blob" }
            );
            saveAs(result.data, `${onTheJobDocument.value.id}.docx`);
          } catch (e) {
            error(e);
          } finally {
            setLoading(false);
          }
        },
        reject: async () => {
          setLoading(true);
          try {
            const result = await axios.post(
              "api/v1/services/onTheJobDocument/download",
              {
                documentNo: onTheJobDocument.value.id,
                printScore: false,
              } as DownloadOnTheJobDocumentRequest,
              { responseType: "blob" }
            );
            saveAs(result.data, `${onTheJobDocument.value.id}.docx`);
          } catch (e) {
            error(e);
          } finally {
            setLoading(false);
          }
        },
      });
    };
    const onAddAttendee = () => {
      onTheJobDocument.value.items?.push({
        onthejobDocumentId: null,
        employeeId: null,
        score: null,
        employee: null,
      } as OnthejobItem);
    };

    const onDeleteAttendee = (index: number) => {
      onTheJobDocument.value.items?.splice(index, 1);
    };
    const onCancelDocument = async () => {
      setLoading(true);
      try {
        await axios.post("api/v1/services/onTheJobDocument/cancel", {
          id: onTheJobDocument.value.id,
        } as CancelOnTheJobDocumentRequest);
        success("ยกเลิกเอกสารเรียบร้อยแล้ว");
        await loadDocument();
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };
    const statusText = computed(() => {
      // return onTheJobDocument.value.submittedDate
      //   ? "ส่งเอกสารแล้ว"
      //   : onTheJobDocument.value.id
      //   ? "บันทึก"
      //   : "สร้างใหม่";
      return onTheJobDocument.value.status ?? "ยังไม่บันทึก";
    });

    const documentId = computed(() => onTheJobDocument.value.id || "N/A");
    const isReadonly = computed(
      () =>
        !!onTheJobDocument.value.submittedDate ||
        !!onTheJobDocument.value.cancelOn
    );

    onMounted(() => loadDocument());

    return {
      onTheJobDocument,
      onSaveDocument,
      onSubmitDocument,
      onExportDocument,
      documentId,
      onAddAttendee,
      onDeleteAttendee,
      onCancelDocument,
      v$,

      selectedTopic,
      mainTopic,
      optionTopic,
      otherTopic,
      submitting,
      description,
      statusText,
      isReadonly,
      isAdmin,
      formatAppDateTime,
      sessionState,
    };
  },
});
</script>

<style></style>
